import axios from 'axios';

export default {

    findItems (page, pageSize,
        reference, 
                
        selectedSection,
        selectedGroupName, selectedSubGroupName, 
        selectedSpecialGroup,
        
        selectedSize,

        filterPriceMin, 
        filterPriceMax, 

        selectedStyle,

        requestTimestamp,
        selectedOptionalItemSectionId) {

        return axios.get('/api/items/list', { params: {page: page, pageSize: pageSize, 

        reference:reference, 
        
        selectedSection: selectedSection, 
        selectedGroupName:selectedGroupName, 
        selectedSubGroupName:selectedSubGroupName,  
        selectedSpecialGroup: selectedSpecialGroup,

        selectedSizeId: selectedSize ? selectedSize.id : null,
   
        filterPriceMin:filterPriceMin, 
        filterPriceMax:filterPriceMax, 

        selectedStyleId: selectedStyle ? selectedStyle.id : null,
                
        requestTimestamp: requestTimestamp , 
        optionalItemSectionId :selectedOptionalItemSectionId } })


        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    loadFilter (reference, 
        selectedSection,
        selectedGroupName, selectedSubGroupName, selectedSpecialGroup , selectedOptionalItemSectionId   ) {

        return axios.get('/api/items/load-filter', { params: {

        reference:reference, 
        
        selectedSection: selectedSection, 
        selectedGroupName:selectedGroupName, 
        selectedSubGroupName:selectedSubGroupName,
        selectedSpecialGroup: selectedSpecialGroup,
        optionalItemSectionId:selectedOptionalItemSectionId
    } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    findItem(reference, selectedSection,
        selectedGroupName, selectedSubGroupName) {

        return axios.get('/api/items/ref', { params: {reference:reference, 
        
        selectedSection: selectedSection, 
        selectedGroupName:selectedGroupName, 
        selectedSubGroupName:selectedSubGroupName,  

        } })


        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getMenu() {
        return axios.get('/api/items/menu')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getAllSection() {
        return axios.get('/api/items/sections')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getGroups () {
        return axios.get('/api/items/groups/')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getCatalogBannerBySectionSeoName (itemSectionSeoName) {
        return axios.get('/api/items/catalog-banner/section', {params: {itemSectionSeoName: itemSectionSeoName  } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },


    getSubGroups (group) {

        if (group != null) {
            return axios.get('/api/items/subgroups/', { params: {groupId:group.id} })
            .then(response => {
                if (response && response.data) return response.data
            })
            .catch(error => {console.log(error);})
        }
    },

    getLookItems (itemRef) {
        return axios.get('/api/items/look/', {params: {itemRef: itemRef  } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getComplementItemsForHome(page, pageSize,ref){
        return axios.get('/api/items/complement/',{params: {page: page, pageSize: pageSize ,ref: ref} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getPriceItemsLook (itemsVariantIds) {
        return axios.get('/api/items/look/price', {params: {itemsVariantIds: itemsVariantIds  } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },
    
    getSimilairItems (page, pageSize,itemRef) {
        return axios.get('/api/items/similar/', {params: {page: page,pageSize: pageSize,itemRef: itemRef  } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getMaxFileSize() {
        return axios.get('/api/items/size')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getClaimTypes() {
        return axios.get('/api/items/claim/type')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    addRating(itemId, rating) {
        return axios.post('/api/items/rating-add', {itemId: itemId, rating: rating})
            .then(response => {
                if (response && response.data) {
                    return response.data;
                }
            })
            .catch(error => {console.log(error);})
    },

    getRatings(itemId) {
        return axios.get('/api/items/ratings', {params: {itemId: itemId} })
            .then(response => {
                if (response && response.data) {
                    return response.data;
                }
            })
            .catch(error => {console.log(error);})
    },


    getOptionalItemSection(sectionName){
        return axios.get('/api/items/optional-sections', {params: {sectionName: sectionName} })
            .then(response => {
                if (response && response.data) {
                    return response.data;
                }
            })
            .catch(error => {console.log(error);})

    },


    setVisitItem(itemId ,originType){
        return axios.post('/api/items/visit', {itemId: itemId , originType:originType})
            .then(response => {
                if (response && response.data) {
                    return response.data;
                }
            })
            .catch(error => {console.log(error);})

    }
}

